import React from 'react'
import Routes from 'routes'
import { connect } from 'react-redux'
import { withRouter, NavLink } from 'react-router-dom'
import { withApp, getItemById, AppContext } from 'helpers'
import { Icon, Button } from 'components/library'
import { translate } from 'translations'
import { config } from 'config'
import './AppDrawer.css'

class AppDrawer extends React.Component {
  handleHome = e => {
    this.props.history.push(Routes.to('home'))
    this.props.app.toggleNavigation()
  }

  componentDidUpdate(props) {
    if(props.app.isNavOpen !== this.props.isNavOpen) {
      if(this.props.app.isNavOpen)
        document.querySelector('html').style.overflowY = 'hidden'
      else
        document.querySelector('html').removeAttribute('style')
    }
  }

  render() {
    return (
      <div className={`App-drawer ${this.props.app.isNavOpen ? 'is-open' : ''}`}>
        {this.props.app.isNavOpen &&
          <div className="App-drawer-overlay" onClick={this.props.app.toggleNavigation}></div>
        }

        {this.props.app.isNavOpen &&
          <div className="App-drawer-content">

            <div className="App-drawer-close">
              <a onClick={this.props.app.toggleNavigation}><Icon name="close" size="large" /></a>
            </div>

            <div className="App-drawer-list">
              {this.props.navigation.map((item, idx) => {
                switch(item.type) {
                  case "page":
                    return <PageNavItem key={idx} {...item}
                      onClose={this.props.app.toggleNavigation}
                      progress={getItemById(this.props.progress, item.id)}
                      page={getItemById(this.props.pages, item.pageId)} />

                  case "chapter":
                    return <ChapterNavItem key={idx} {...item}
                      onClose={this.props.app.toggleNavigation}
                      progress={getItemById(this.props.progress, item.id)}
                      chapter={getItemById(this.props.chapters, item.chapterId)} />

                  case "endtest":
                    return <EndtestNavItem key={idx} {...item}
                      onClose={this.props.app.toggleNavigation}
                      progress={getItemById(this.props.progress, item.id)} />

                  default:
                    return false
                }
              })}
            </div>

            <AppContext.Consumer>
              {({ toggleModal, triggerEvent }) => (
                <div className="App-drawer-footer">
                  <Button onClick={this.handleHome} label={translate('app.home')} icon="home" iconPos="top" />
                  {/*<Button onClick={(e) => toggleModal(e, 'help')} label={translate('app.help')} icon="info" iconPos="top" />*/}
                  <Button onClick={() => triggerEvent('exit')} label={translate('app.logout')} icon="logout" iconPos="top" />
                </div>
              )}
            </AppContext.Consumer>
          </div>
        }
      </div>
    )
  }
}

const PageNavItem = props => (
  <div className={`App-drawer-list-item is-${props.progress.status}`}>
    <NavLink to={Routes.to('page', { page: props.page.slug })} onClick={props.onClose}>
      {props.page.title}
    </NavLink>
  </div>
)

const setItemClass = (progress, status, idx) => {
  let className = config.linearMode ? 'locked' : 'done'

  if(config.linearMode) {
    if(status === 'active') {
      if(progress > idx) className = 'done'
      if(progress === idx) className= 'active'
    }
  }

  if(status === 'done') {
    className = 'done'
  }

  if(status === 'locked') {
    className = 'locked'
  }

  return `is-${className}`
}

const ChapterNavItem = props => (
  <div className={`App-drawer-list-item is-${props.progress.status}`}>
    <NavLink to={Routes.to('chapter', { chapter: props.chapter.slug })} onClick={props.onClose}>
      {props.chapter.title}
    </NavLink>

    {props.chapter.aspects.length > 1 &&
      <div className="App-drawer-sublist">
        {props.chapter.aspects.map((item, idx) => (
          <NavLink key={idx}
            to={Routes.to('aspect', { chapter: props.chapter.slug, aspect: item.id })}
            onClick={props.onClose}
            className={setItemClass(props.progress.progress, props.progress.status, idx)}>
            {item.title}
          </NavLink>
        ))}
      </div>
    }
  </div>
)

const EndtestNavItem = props => (
  <div className={`App-drawer-list-item is-${props.progress.status}`}>
    <NavLink to={Routes.to('endtest')} onClick={props.onClose}>
      {translate('endtest.title')}
    </NavLink>
  </div>
)

export default withRouter(withApp(connect(
  (state, props) => {
    const navigation = state.account.user.role === 'student'
      ? state.content.navigation.filter(item => item.role !== 'coach')
      : state.content.navigation

    return {
      progress: state.account.progress,
      navigation,
      chapters: state.content.chapters,
      pages: state.content.pages,
    }
  },
  (dispatch) => ({})
)(AppDrawer)))



// WEBPACK FOOTER //
// ./src/components/layout/drawer/AppDrawer.js